export default __webpack_public_path__ + "static/media/Standard38.101a554a.png";